export default function toBrDate(date, ajustaHora = false, isNascimento = false) {
	if (date) {
		const dateAux = new Date(date);
		const y = dateAux.getFullYear();
		const m = ('0' + (dateAux.getMonth() + 1)).slice(-2);
		const d = ('0' + dateAux.getDate()).slice(-2);
		const h = ('0' + (dateAux.getHours() + (ajustaHora ? 3 : 0))).slice(-2);
		const mm = ('0' + dateAux.getMinutes()).slice(-2);
		// const year = date.substring(0, 4);
		// const month = date.substring(5, 7);
		// const day = date.substring(8, 10);
		// const hour = date.substring(11, 13);
		// const minute = date.substring(14, 16);
		return isNascimento ?  `${d}/${m}/${y}` : `${d}/${m}/${y} às ${h}:${mm}`
	}
}
